import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { message } from 'antd';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { HiUser, HiLockClosed } from 'react-icons/hi';
import { PostAuth } from '../../Api/PostData';
import Swal from 'sweetalert2';
import { useAuth } from '../../context/AuthContext';

const Login = () => {

    useEffect(() => {
        document.title = "Santan IOT - Login";
    }, []);

    const navigate = useNavigate();
    const { setAuth, isAuthenticated } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/monitoring');
        }
    }, [navigate, isAuthenticated])


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            const response = await PostAuth(formData);
            // console.log(response);
            if (response.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Login Success !',
                    text: response.data.message,
                    confirmButtonText: 'OK',
                });
                setAuth(response.data.user, response.data.token);
                navigate('/monitoring');
            }
        } catch (error) {
            console.log(error);
            if (error.response.status === 400) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Not Found !',
                    text: error.response.data.message,
                });
            } else if (error.response.status === 401) {
                Swal.fire({
                    icon: 'info',
                    title: 'Login Failed !',
                    text: error.response.data.message,
                });
            } else if (error.response.status === 500) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Internal Server Error !',
                    text: error.response.data.message,
                });
            }
            else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error !',
                    text: error.response.data.message,
                });
            }
        } finally {
            setIsLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">

            <div className="relative w-full max-w-6xl mx-auto">
                <div className="bg-white/80 backdrop-blur-xl rounded-3xl shadow-2xl overflow-hidden border border-white/20">
                    <div className="flex flex-col lg:flex-row min-h-[600px]">
                        {/* Left Side - Login Form */}
                        <div className="flex-1 p-8 lg:p-12 flex flex-col justify-center">
                            <div className="max-w-md mx-auto w-full">
                                {/* Logo */}
                                <div className="text-center mb-8">
                                    <Link to="/" className="inline-block">
                                        <img
                                            src="/assets/logo-santan.png"
                                            alt="Santan Logo"
                                            className="h-16 mx-auto mb-4 drop-shadow-lg"
                                        />
                                    </Link>
                                    <h1 className="text-3xl lg:text-4xl font-bold gradient-text mb-2">
                                        Welcome Back!
                                    </h1>
                                    <p className="text-gray-600">
                                        Sign in to your Marine IOT Dashboard
                                    </p>
                                </div>

                                {/* Login Form */}
                                <form onSubmit={handleSubmit} className="space-y-6">
                                    <div className="space-y-4">
                                        <div>
                                            <label htmlFor="Username" className="block text-sm font-semibold text-gray-700 mb-2">
                                                Username
                                            </label>
                                            <div className="relative">
                                                <input
                                                    id="Username"
                                                    name="username"
                                                    type="text"
                                                    required
                                                    autoComplete="username"
                                                    value={formData.username}
                                                    onChange={handleChange}
                                                    className="input-modern pl-12"
                                                    placeholder="Enter your username"
                                                />
                                                <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
                                                    <HiUser className="w-5 h-5 text-gray-400" />
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <label htmlFor="Password" className="block text-sm font-semibold text-gray-700 mb-2">
                                                Password
                                            </label>
                                            <div className="relative">
                                                <input
                                                    id="Password"
                                                    name="password"
                                                    type={showPassword ? "text" : "password"}
                                                    required
                                                    autoComplete="current-password"
                                                    value={formData.password}
                                                    onChange={handleChange}
                                                    className="input-modern pl-12 pr-12"
                                                    placeholder="Enter your password"
                                                />
                                                <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
                                                    <HiLockClosed className="w-5 h-5 text-gray-400" />
                                                </div>
                                                <button
                                                    type="button"
                                                    onClick={togglePasswordVisibility}
                                                    className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors duration-200"
                                                >
                                                    {showPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <button
                                        type="submit"
                                        disabled={isLoading}
                                        className={`w-full btn-primary ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    >
                                        {isLoading ? (
                                            <div className="flex items-center justify-center space-x-2">
                                                <div className="spinner w-4 h-4"></div>
                                                <span>Signing in...</span>
                                            </div>
                                        ) : (
                                            'Sign In'
                                        )}
                                    </button>
                                </form>

                                {/* Demo Credentials */}
                                {/* <div className="mt-8 p-4 bg-blue-50 rounded-xl border border-blue-200">
                                    <h3 className="text-sm font-semibold text-blue-800 mb-2">Demo Credentials:</h3>
                                    <div className="text-xs text-blue-700 space-y-1">
                                        <p><strong>Admin:</strong> Office / SantanIOTDashboard</p>
                                        <p><strong>User:</strong> G2008 / G2008</p>
                                    </div>
                                </div> */}
                            </div>
                        </div>

                        {/* Right Side - Hero Image */}
                        <div className="hidden lg:block lg:w-1/2 relative">
                            <div
                                className="h-full bg-cover bg-center relative"
                                style={{ backgroundImage: "url('/assets/kapal-santan.jpg')" }}
                            >
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                                <div className="absolute bottom-8 left-8 right-8 text-white">
                                    <h2 className="text-2xl font-bold mb-2">Marine IOT Monitoring</h2>
                                    <p className="text-blue-100">
                                        Real-time monitoring and analytics for marine vessels with advanced sensor technology.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
